/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/


import { useAuthContext } from "../../hooks/useAuthContext";

import CreateTicket from "./tickets/create";
import StatsPage from "./stats";

const Tables = () => {

  const { user } = useAuthContext();

  // return (user.role === "rh") ? <RhTables /> : <RespTables />;

  return (user.role === "user") ? <CreateTicket /> : <StatsPage />;
}

export default Tables;
